import { render, staticRenderFns } from "./AddDelegado.vue?vue&type=template&id=16bf2c19&"
import script from "./AddDelegado.vue?vue&type=script&lang=js&"
export * from "./AddDelegado.vue?vue&type=script&lang=js&"
import style0 from "./AddDelegado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports